module.exports = __webpack_public_path__ + "img/imagem-04-detalhada-palmeiras-02.a45a585e.png";